// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6756a751","879":"dd426dee"}[chunkId] + ".chunk.js";
};